import { useState } from 'react'
import { cn } from '@/lib/cn'

/**
 * A person's picture, falling back to their initials.
 *
 * The fallback is decorative — the name is always rendered next to it in this app, so repeating
 * it here would make a screen reader say it twice.
 */
export function Avatar({
  src,
  name,
  size = 28,
  className,
}: {
  src: string | null | undefined
  name: string
  size?: number
  className?: string
}) {
  const [hasFailed, setHasFailed] = useState(false)

  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')

  return (
    <span
      aria-hidden
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full',
        'bg-primary-subtle font-medium text-primary select-none',
        className,
      )}
    >
      {src && !hasFailed ? (
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          onError={() => { setHasFailed(true) }}
          className="size-full object-cover"
        />
      ) : (
        (initials || '?')
      )}
    </span>
  )
}
